import React from 'react';
import PropTypes from 'prop-types';
import { DragDropContext, Droppable } from '@hello-pangea/dnd';

const DragDropContextComponent = ({
  draggableItems, onDragEnd, getListStyle = () => ({}), direction = 'vertical', className = '',
}) => {
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="droppable" direction={direction}>
        {(provided, snapshot) => (
          <div
            {...provided.droppableProps}
            ref={provided.innerRef}
            style={getListStyle(snapshot.isDraggingOver)}
            className={className}
          >
            {draggableItems}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};

DragDropContextComponent.propTypes = {
  draggableItems: PropTypes.array.isRequired,
  onDragEnd: PropTypes.func.isRequired,
  getListStyle: PropTypes.func,
  direction: PropTypes.string,
  className: PropTypes.string,
};

export default DragDropContextComponent;
